import Cookies from 'js-cookie'

/**
 * Passes Facebook's click identifiers along to the merchant's store.
 *
 * When someone arrives from a Facebook ad, Facebook leaves two cookies
 * identifying that click. The store this site sends readers to lives on a
 * different domain and so cannot read them, and without them a resulting sale
 * cannot be traced back to the ad that produced it. So the identifiers are
 * appended to the outbound links instead.
 *
 * The cookies are not always there the moment the page loads, hence the
 * polling: it checks once a second and stops as soon as it finds one.
 */
export function useFacebookCookies() {
    let timer: ReturnType<typeof setInterval> | undefined
    let fbc = ''
    let fbp = ''

    /**
     * Start watching for the cookies. Safe to call again on each page
     * navigation; any previous watch is cancelled first.
     */
    function appendFacebookCookiesToLinks(): void {
        clearInterval(timer)

        timer = setInterval(() => {
            refresh()
            append()
        }, 1000)
    }

    /** Re-read the two cookies. */
    function refresh(): void {
        fbc = Cookies.get('_fbc') || ''
        fbp = Cookies.get('_fbp') || ''
    }

    /**
     * Append whichever identifiers were found to every link pointing at the
     * store. Does nothing until at least one cookie exists; once one does, it
     * appends them and stops the polling.
     */
    function append(): void {
        if (!fbc && !fbp) {
            return
        }

        clearInterval(timer)

        for (const anchor of document.getElementsByTagName('a')) {
            if (!anchor.href.includes('nutreance.com')) {
                continue
            }

            const url = anchor.href.includes('?') ? anchor.href.split('?')[0] : anchor.href

            switch (true) {
                case !!fbc && !!fbp: {
                    anchor.href = `${url}?fbc=${fbc}&fbp=${fbp}`
                    break
                }

                case !!fbc: {
                    anchor.href = `${url}?fbc=${fbc}`
                    break
                }

                case !!fbp: {
                    anchor.href = `${url}?fbp=${fbp}`
                    break
                }

                default: {
                    break
                }
            }
        }
    }

    return {
        appendFacebookCookiesToLinks,
    }
}
